import { observer } from 'mobx-react-lite';
import { useTranslation } from 'react-i18next';
import { useNavigate } from 'react-router';
import { useStore } from '../../../hooks/useStore';
import { ContentHead } from '../../../lib/components';
import { ContentBox } from '../../../lib/components/compound/pages/contentBox';
import { BenefitEnum, CompanyBenefitSettings } from '@pxtra-client-lib-legacy/gen';
import { useCreateCustomBenefit } from '../../actions/createCustomBenefit/hooks/useCreateCustomBenefit';
import { useDialog } from '../../../lib/components/compound/dialogs/confirmationDialog/useDialog';
import { ContractInformation } from '../../company/settings/shared/contractInfo';
import { BenefitPortfolioTable } from '../../../lib/components/tables/portfolio/portfolio';

export type BenefitsSettingsListItem = {
  id: string | keyof CompanyBenefitSettings;
  custom?: boolean;
};

export const Portfolio = observer(() => {
  const { t } = useTranslation();
  const navigate = useNavigate();
  const { companyStore } = useStore();
  const { newCustomBenefit } = useCreateCustomBenefit();

  const dialog = useDialog<string>();

  const handleClickCustomBenefit = async (row: BenefitsSettingsListItem) => {
    if (row.custom) {
      const result = await companyStore.fetchCustomBenefit(row.id);
      newCustomBenefit.loadCustomBenefit(result);
      newCustomBenefit.editingBenefitId = row.id;
      navigate('/actions/custom-benefit/edit_custom_benefit/1');
    }
  };

  return (
    <ContentBox
      headComponent={
        <ContentHead
          headline={t('benefits:benefit_portfolio')}
          subtitle={t('benefits:benefit_portfolio_subtitle')}
          showActions={false}
        />
      }
    >
      <BenefitPortfolioTable
        onInfoClick={(benefitId) => dialog.setDialogRelevantValue(benefitId)}
        onEditClick={handleClickCustomBenefit}
      />
      <ContractInformation
        benefit={dialog.dialogRelevantValue as BenefitEnum}
        open={dialog.dialogProps.open}
        onClose={dialog.dialogProps.onClose}
      />
    </ContentBox>
  );
});
